import { z } from 'zod';

import { baseOrganizationEntitySchema } from './organizationContract';
import { FeedSource, FeedStatus, UpdateFrequency } from '../enums';

export const FeedSchema = baseOrganizationEntitySchema.extend({
  name: z.string().max(100),
  url: z.string().url(),
  source: z.nativeEnum(FeedSource),
  chat: z.string().uuid(),
  scheduledAt: z.coerce.date().nullish(),
  content: z.string().nullish(),
  updateFrequency: z.nativeEnum(UpdateFrequency),
  status: z.nativeEnum(FeedStatus).nullish(),
  importMetadata: z
    .object({
      retries: z.number().int().positive().nullish(),
      lastError: z.string().nullish(),
    })
    .nullish(),
});

export const createFeedSchema = FeedSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  organization: true,
  status: true,
  importMetadata: true,
  scheduledAt: true,
  content: true,
}).strict();

export const updateFeedSchema = FeedSchema.partial()
  .required({
    id: true,
  })
  .omit({
    organization: true,
  })
  .strict();

export type FeedDTO = z.infer<typeof FeedSchema>;
export type CreateFeedDTO = z.infer<typeof createFeedSchema>;
export type UpdateFeedDTO = z.infer<typeof updateFeedSchema>;
